// import React from 'react';
// import { Link } from 'react-router-dom';

// const AttractionsDetails = () => {
//   const categories = [
//     {
//       title: 'Przyroda i krajobrazy',
//       items: [
//         'Lisi Jar',
//         'Wąwóz Chłapowski',
//         'Klif w Jastrzębiej Górze',
//         'Gwiazda Północy',
//         'Wydmy ruchome w Łebie'
//       ],
//       image: '/images/krajobraz.jpg'
//     },
//     {
//       title: 'Zabytki i kultura',
//       items: [
//         'Latarnia Morska w Rozewiu',
//         'Muzeum Latarnictwa',
//         'Promenada Światowida',
//         'Zabytkowe kościoły',
//         'Groty w Mechowie'
//       ],
//       image: '/images/zabytki.jpg'
//     },
//     {
//       title: 'Aktywny wypoczynek',
//       items: [
//         'Plaże Jastrzębiej Góry',
//         'Ścieżki rowerowe i piesze',
//         'Spływy kajakowe',
//         'Jazda konna',
//         'Loty widokowe'
//       ],
//       image: '/images/aktywnywypoczynek.jpg'
//     },
//     {
//       title: 'Atrakcje dla rodzin',
//       items: [
//         'Wodny Park Primavera',
//         'Parki rozrywki',
//         'Plac zabaw nad brzegiem morza',
//         'Rejsy statkiem',
//         'Mini zoo'
//       ],
//       image: '/images/atrakcjedlarodzin.jpg'
//     }
//   ];

//   return (
//     <div className="bg-[#edece8] min-h-screen py-12">
//       <div className="max-w-6xl mx-auto px-4">
//         <div className="text-center mb-12">
//           <h1 className="text-4xl font-bold text-gray-800 mb-4">Atrakcje Jastrzębiej Góry i okolic</h1>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//             Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy
//           </p>
//         </div>

//         <div className="grid md:grid-cols-2 gap-8 mb-12">
//           {categories.map((category, index) => (
//             <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
//               <div className="h-48 overflow-hidden">
//                 <img 
//                   src={category.image} 
//                   alt={category.title}
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//               <div className="p-6">
//                 <h2 className="text-2xl font-bold text-yellow-600 mb-4">{category.title}</h2>
//                 <ul className="space-y-2">
//                   {category.items.map((item, i) => (
//                     <li key={i} className="flex items-start">
//                       <span className="text-yellow-500 mr-2 mt-1">•</span>
//                       {item}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="bg-white rounded-xl shadow-lg p-8">
//           <h2 className="text-2xl font-bold text-gray-800 mb-4">Inne wyjątkowe miejsca</h2>
//           <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
//             {[
//               'Dom Whisky w Jastrzębiej Górze',
//               'Półwysep Helski',
//               'Fokarium w Helu',
//               'Muzeum Rybołówstwa',
//               'Ocean Park we Władysławowie',
//               'Rezerwat przyrody Bielawa'
//             ].map((item, index) => (
//               <div key={index} className="flex items-center p-3 bg-gray-50 rounded-lg">
//                 <span className="text-yellow-500 mr-2">•</span>
//                 {item}
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="mt-12 text-center">
//           <Link 
//             to="/" 
//             className="inline-block bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-full transition-colors duration-300"
//           >
//             Powrót do strony głównej
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AttractionsDetails;

// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';

// const AttractionsDetails = () => {
//   const [attractionsData, setAttractionsData] = useState({
//     details: {
//       title: "Atrakcje Jastrzębiej Góry i okolic",
//       description: "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy",
//       categories: [],
//       otherPlaces: []
//     }
//   });

//   useEffect(() => {
//     const savedData = localStorage.getItem('attractionsData');
//     if (savedData) {
//       try {
//         setAttractionsData(JSON.parse(savedData));
//       } catch (error) {
//         console.error('Błąd parsowania danych atrakcji:', error);
//       }
//     }
//   }, []);

//   return (
//     <div className="bg-[#edece8] min-h-screen py-12">
//       <div className="max-w-6xl mx-auto px-4">
//         <div className="text-center mb-12">
//           <h1 className="text-4xl font-bold text-gray-800 mb-4">{attractionsData.details.title}</h1>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//             {attractionsData.details.description}
//           </p>
//         </div>

//         <div className="grid md:grid-cols-2 gap-8 mb-12">
//           {attractionsData.details.categories.map((category, index) => (
//             <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
//               <div className="h-48 overflow-hidden">
//                 <img 
//                   src={category.image} 
//                   alt={category.title}
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//               <div className="p-6">
//                 <h2 className="text-2xl font-bold text-yellow-600 mb-4">{category.title}</h2>
//                 <ul className="space-y-2">
//                   {category.items.map((item, i) => (
//                     <li key={i} className="flex items-start">
//                       <span className="text-yellow-500 mr-2 mt-1">•</span>
//                       {item}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="bg-white rounded-xl shadow-lg p-8">
//           <h2 className="text-2xl font-bold text-gray-800 mb-4">Inne wyjątkowe miejsca</h2>
//           <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
//             {attractionsData.details.otherPlaces.map((item, index) => (
//               <div key={index} className="flex items-center p-3 bg-gray-50 rounded-lg">
//                 <span className="text-yellow-500 mr-2">•</span>
//                 {item}
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="mt-12 text-center">
//           <Link 
//             to="/" 
//             className="inline-block bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-full transition-colors duration-300"
//           >
//             Powrót do strony głównej
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AttractionsDetails;

// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';

// const AttractionsDetails = () => {
//   const [attractionsData, setAttractionsData] = useState({
//     details: {
//       title: "Atrakcje Jastrzębiej Góry i okolic",
//       description: "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy",
//       categories: [],
//       otherPlaces: []
//     }
//   });

//   useEffect(() => {
//     // Automatyczne przewijanie do góry po załadowaniu komponentu
//     window.scrollTo(0, 0);
    
//     const savedData = localStorage.getItem('attractionsData');
//     if (savedData) {
//       try {
//         setAttractionsData(JSON.parse(savedData));
//       } catch (error) {
//         console.error('Błąd parsowania danych atrakcji:', error);
//       }
//     }
//   }, []);

//   return (
//     <div className="bg-[#edece8] min-h-screen py-12">
//       <div className="max-w-6xl mx-auto px-4">
//         <div className="text-center mb-12">
//           <h1 className="text-4xl font-bold text-gray-800 mb-4">{attractionsData.details.title}</h1>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//             {attractionsData.details.description}
//           </p>
//         </div>

//         <div className="grid md:grid-cols-2 gap-8 mb-12">
//           {attractionsData.details.categories.map((category, index) => (
//             <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
//               <div className="h-48 overflow-hidden">
//                 <img 
//                   src={category.image} 
//                   alt={category.title}
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//               <div className="p-6">
//                 <h2 className="text-2xl font-bold text-yellow-600 mb-4">{category.title}</h2>
//                 <ul className="space-y-2">
//                   {category.items.map((item, i) => (
//                     <li key={i} className="flex items-start">
//                       <span className="text-yellow-500 mr-2 mt-1">•</span>
//                       {item}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="bg-white rounded-xl shadow-lg p-8">
//           <h2 className="text-2xl font-bold text-gray-800 mb-4">Inne wyjątkowe miejsca</h2>
//           <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
//             {attractionsData.details.otherPlaces.map((item, index) => (
//               <div key={index} className="flex items-center p-3 bg-gray-50 rounded-lg">
//                 <span className="text-yellow-500 mr-2">•</span>
//                 {item}
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="mt-12 text-center">
//           <Link 
//             to="/" 
//             className="inline-block bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-full transition-colors duration-300"
//           >
//             Powrót do strony głównej
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AttractionsDetails;

// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';

// const AttractionsDetails = () => {
//   const API_BASE = 'http://localhost/api';
  
//   const [attractionsData, setAttractionsData] = useState({
//     details: {
//       title: "Atrakcje Jastrzębiej Góry i okolic",
//       description: "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy",
//       categories: [],
//       otherPlaces: []
//     }
//   });
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     // Automatyczne przewijanie do góry po załadowaniu komponentu
//     window.scrollTo(0, 0);
    
//     const fetchAttractionsData = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${API_BASE}/attractions.php`);
        
//         if (!response.ok) {
//           throw new Error('Błąd podczas pobierania danych atrakcji');
//         }
        
//         const data = await response.json();
//         setAttractionsData(data);
//       } catch (error) {
//         console.error('Błąd ładowania danych atrakcji:', error);
//         //setError('Nie udało się załadować danych atrakcji. Wyświetlam domyślną zawartość.');
//         // Używamy domyślnych danych w przypadku błędu
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAttractionsData();
//   }, []);

//   if (loading) {
//     return (
//       <div className="bg-[#edece8] min-h-screen py-12 flex items-center justify-center">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-[#edece8] min-h-screen py-12">
//       <div className="max-w-6xl mx-auto px-4">
//         {/* Komunikat o błędzie */}
//         {error && (
//           <div className="mb-6 bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">
//             {error}
//           </div>
//         )}

//         <div className="text-center mb-12">
//           <h1 className="text-4xl font-bold text-gray-800 mb-4">
//             {attractionsData.details?.title || "Atrakcje Jastrzębiej Góry i okolic"}
//           </h1>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//             {attractionsData.details?.description || "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy"}
//           </p>
//         </div>

//         <div className="grid md:grid-cols-2 gap-8 mb-12">
//           {attractionsData.details.categories && attractionsData.details.categories.length > 0 ? (
//             attractionsData.details.categories.map((category, index) => (
//               <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
//                 <div className="h-48 overflow-hidden">
//                   <img 
//                     src={category.image || '/images/placeholder.jpg'} 
//                     alt={category.title}
//                     className="w-full h-full object-cover"
//                     onError={(e) => {
//                       e.target.src = '/images/placeholder.jpg';
//                     }}
//                   />
//                 </div>
//                 <div className="p-6">
//                   <h2 className="text-2xl font-bold text-yellow-600 mb-4">
//                     {category.title || "Kategoria atrakcji"}
//                   </h2>
//                   <ul className="space-y-2">
//                     {category.items && category.items.length > 0 ? (
//                       category.items.map((item, i) => (
//                         <li key={i} className="flex items-start">
//                           <span className="text-yellow-500 mr-2 mt-1">•</span>
//                           {item}
//                         </li>
//                       ))
//                     ) : (
//                       <li className="text-gray-500">Brak atrakcji w tej kategorii</li>
//                     )}
//                   </ul>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="col-span-2 text-center py-12">
//               <p className="text-gray-500 text-xl">Brak dostępnych kategorii atrakcji</p>
//             </div>
//           )}
//         </div>

//         {attractionsData.details.otherPlaces && attractionsData.details.otherPlaces.length > 0 && (
//           <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
//             <h2 className="text-2xl font-bold text-gray-800 mb-4">Inne wyjątkowe miejsca</h2>
//             <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
//               {attractionsData.details.otherPlaces.map((item, index) => (
//                 <div key={index} className="flex items-center p-3 bg-gray-50 rounded-lg">
//                   <span className="text-yellow-500 mr-2">•</span>
//                   {item}
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         <div className="mt-12 text-center">
//           <Link 
//             to="/" 
//             className="inline-block bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-full transition-colors duration-300"
//           >
//             Powrót do strony głównej
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AttractionsDetails;

// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';

// const AttractionsDetails = () => {
//   const API_BASE = process.env.NODE_ENV === 'production' 
//     ? '/kolorowedomki/api' 
//     : 'http://localhost/api';
  
//   const [attractionsData, setAttractionsData] = useState({
//     details: {
//       title: "Atrakcje Jastrzębiej Góry i okolic",
//       description: "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy",
//       categories: [],
//       otherPlaces: []
//     }
//   });
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     window.scrollTo(0, 0);
    
//     const fetchAttractionsData = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${API_BASE}/attractions.php`);
        
//         if (!response.ok) {
//           throw new Error('Błąd podczas pobierania danych atrakcji');
//         }
        
//         const data = await response.json();
//         setAttractionsData(data);
//       } catch (error) {
//         console.error('Błąd ładowania danych atrakcji:', error);
//         //setError('Nie udało się załadować danych atrakcji. Wyświetlam domyślną zawartość.');
        
//         // Dane tymczasowe jako fallback
//         setAttractionsData({
//           details: {
//             title: "Atrakcje Jastrzębiej Góry i okolic",
//             description: "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy",
//             categories: [
//               {
//                 title: "Atrakcje Przyrodnicze",
//                 image: "/images/nature.jpg",
//                 items: [
//                   "Klif w Jastrzębiej Górze",
//                   "Rezerwat Przylądek Rozewie", 
//                   "Latarnia morska w Rozewiu",
//                   "Plaża w Jastrzębiej Górze"
//                 ]
//               },
//               {
//                 title: "Atrakcje Historyczne", 
//                 image: "/images/history.jpg",
//                 items: [
//                   "Muzeum Latarnictwa",
//                   "Dworek Drzewiarza",
//                   "Stara Chata Rybacka"
//                 ]
//               }
//             ],
//             otherPlaces: [
//               "Władysławowo",
//               "Chłapowo",
//               "Rozewie", 
//               "Gdynia",
//               "Gdańsk"
//             ]
//           }
//         });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAttractionsData();
//   }, [API_BASE]);

//   if (loading) {
//     return (
//       <div className="bg-[#edece8] min-h-screen py-12 flex items-center justify-center">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-[#edece8] min-h-screen py-12">
//       <div className="max-w-6xl mx-auto px-4">
//         {/* Komunikat o błędzie */}
//         {error && (
//           <div className="mb-6 bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">
//             {error}
//           </div>
//         )}

//         {/* Nagłówek sekcji */}
//         <div className="text-center mb-12">
//           <h1 className="text-4xl font-bold text-gray-800 mb-4">
//             {attractionsData.details?.title || "Atrakcje Jastrzębiej Góry i okolic"}
//           </h1>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//             {attractionsData.details?.description || "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy"}
//           </p>
//         </div>

//         {/* Kategorie atrakcji */}
//         <div className="grid md:grid-cols-2 gap-8 mb-12">
//           {attractionsData.details.categories && attractionsData.details.categories.length > 0 ? (
//             attractionsData.details.categories.map((category, index) => (
//               <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
//                 <div className="h-48 overflow-hidden">
//                   <img 
//                     src={category.image || '/images/placeholder.jpg'} 
//                     alt={category.title}
//                     className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
//                     onError={(e) => {
//                       e.target.src = '/images/placeholder.jpg';
//                     }}
//                   />
//                 </div>
//                 <div className="p-6">
//                   <h2 className="text-2xl font-bold text-yellow-600 mb-4">
//                     {category.title || "Kategoria atrakcji"}
//                   </h2>
//                   <ul className="space-y-2">
//                     {category.items && category.items.length > 0 ? (
//                       category.items.map((item, i) => (
//                         <li key={i} className="flex items-start text-gray-700 hover:text-gray-900 transition-colors duration-200">
//                           <span className="text-yellow-500 mr-2 mt-1">•</span>
//                           <span>{item}</span>
//                         </li>
//                       ))
//                     ) : (
//                       <li className="text-gray-500">Brak atrakcji w tej kategorii</li>
//                     )}
//                   </ul>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="col-span-2 text-center py-12">
//               <p className="text-gray-500 text-xl">Brak dostępnych kategorii atrakcji</p>
//             </div>
//           )}
//         </div>

//         {/* Inne wyjątkowe miejsca */}
//         {attractionsData.details.otherPlaces && attractionsData.details.otherPlaces.length > 0 && (
//           <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
//             <h2 className="text-2xl font-bold text-gray-800 mb-6">Inne wyjątkowe miejsca w okolicy</h2>
//             <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
//               {attractionsData.details.otherPlaces.map((item, index) => (
//                 <div key={index} className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200">
//                   <span className="text-yellow-500 mr-3 text-lg">•</span>
//                   <span className="text-gray-700">{item}</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Dodatkowa informacja */}
//         <div className="bg-blue-50 rounded-xl p-6 mb-8 border border-blue-200">
//           <h3 className="text-xl font-semibold text-blue-800 mb-3">Planujesz pobyt?</h3>
//           <p className="text-blue-700">
//             Wszystkie wymienione atrakcje znajdują się w odległości do 30 km od Jastrzębiej Góry. 
//             Idealne na jednodniowe wycieczki podczas Twojego pobytu w naszych domkach.
//           </p>
//         </div>

//         {/* Przycisk powrotu */}
//         <div className="mt-12 text-center">
//           <Link 
//             to="/" 
//             className="inline-block bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-full transition-colors duration-300 transform hover:scale-105"
//           >
//             Powrót do strony głównej
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AttractionsDetails;

// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';

// const AttractionsDetails = () => {
//   const API_BASE = process.env.NODE_ENV === 'production' 
//     ? '/kolorowedomki/api' 
//     : 'http://localhost/api';
  
//   const [attractionsData, setAttractionsData] = useState({
//     details: {
//       title: "Atrakcje Jastrzębiej Góry i okolic",
//       description: "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy",
//       categories: [],
//       otherPlaces: []
//     }
//   });
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     window.scrollTo(0, 0);
    
//     const fetchAttractionsData = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${API_BASE}/attractions.php`);
        
//         if (!response.ok) {
//           throw new Error('Błąd podczas pobierania danych atrakcji');
//         }
        
//         const data = await response.json();
//         setAttractionsData(data);
//       } catch (error) {
//         console.error('Błąd ładowania danych atrakcji:', error);
//         setError('Nie udało się załadować danych atrakcji. Wyświetlam domyślną zawartość.');
        
//         // Dane tymczasowe z POPRAWNYMI nazwami obrazów
//         setAttractionsData({
//           details: {
//             title: "Atrakcje Jastrzębiej Góry i okolic",
//             description: "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy",
//             categories: [
//               {
//                 title: "Atrakcje Przyrodnicze",
//                 image: "/images/krajobraz.jpg",
//                 items: [
//                   "Klif w Jastrzębiej Górze",
//                   "Rezerwat Przylądek Rozewie", 
//                   "Latarnia morska w Rozewiu",
//                   "Plaża w Jastrzębiej Górze",
//                   "Lisi Jar - malowniczy wąwóz",
//                   "Rezerwat Bielawa - torfowiska"
//                 ]
//               },
//               {
//                 title: "Atrakcje Historyczne", 
//                 image: "/images/zabytki.jpg",
//                 items: [
//                   "Muzeum Latarnictwa w Rozewiu",
//                   "Dworek Drzewiarza w Jastrzębiej Górze",
//                   "Stara Chata Rybacka",
//                   "Kościół św. Ignacego",
//                   "Fortyfikacje z II Wojny Światowej"
//                 ]
//               },
//               {
//                 title: "Aktywny Wypoczynek",
//                 image: "/images/aktywnywypoczynek.jpg",
//                 items: [
//                   "Szlaki rowerowe Północnych Kaszub",
//                   "Spływy kajakowe Redą",
//                   "Surfowanie na plaży w Jastrzębiej Górze",
//                   "Trasy nordic walking",
//                   "Rejsy kutrem rybackim"
//                 ]
//               },
//               {
//                 title: "Dla Rodzin z Dziećmi",
//                 image: "/images/atrakcjedlarodzin.jpg",
//                 items: [
//                   "Ocean Park we Władysławowie",
//                   "Lunapark Sowiński",
//                   "Park Rozrywki w Redłowie",
//                   "Fokarium na Helu",
//                   "Park Miniatur w Dobrzycy"
//                 ]
//               }
//             ],
//             otherPlaces: [
//               "Władysławowo - słynny port rybacki",
//               "Chłapowo - malownicza wioska rybacka", 
//               "Rozewie - najstarsza latarnia morska",
//               "Gdynia - nowoczesne miasto portowe",
//               "Gdańsk - historyczne stare miasto",
//               "Hel - półwysep i fokarium",
//               "Puck - miasto z historią hanzeatycką",
//               "Żarnowiec - jezioro i elektrownia"
//             ]
//           }
//         });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAttractionsData();
//   }, [API_BASE]);

//   if (loading) {
//     return (
//       <div className="bg-[#edece8] min-h-screen py-12 flex items-center justify-center">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
//         <p className="ml-4 text-gray-600">Ładowanie atrakcji...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-[#edece8] min-h-screen py-12">
//       <div className="max-w-6xl mx-auto px-4">
//         {error && (
//           <div className="mb-6 bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">
//             {error}
//           </div>
//         )}

//         <div className="text-center mb-12">
//           <h1 className="text-4xl font-bold text-gray-800 mb-4">
//             {attractionsData.details?.title}
//           </h1>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//             {attractionsData.details?.description}
//           </p>
//         </div>

//         <div className="grid md:grid-cols-2 gap-8 mb-12">
//           {attractionsData.details.categories && attractionsData.details.categories.length > 0 ? (
//             attractionsData.details.categories.map((category, index) => (
//               <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
//                 <div className="h-48 overflow-hidden">
//                   <img 
//                     src={category.image} 
//                     alt={category.title}
//                     className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
//                     onError={(e) => {
//                       e.target.src = '/kolorowedomki/images/placeholder.jpg';
//                     }}
//                   />
//                 </div>
//                 <div className="p-6">
//                   <h2 className="text-2xl font-bold text-yellow-600 mb-4">
//                     {category.title}
//                   </h2>
//                   <ul className="space-y-2">
//                     {category.items && category.items.length > 0 ? (
//                       category.items.map((item, i) => (
//                         <li key={i} className="flex items-start text-gray-700 hover:text-gray-900 transition-colors duration-200">
//                           <span className="text-yellow-500 mr-2 mt-1">•</span>
//                           <span>{item}</span>
//                         </li>
//                       ))
//                     ) : (
//                       <li className="text-gray-500">Brak atrakcji w tej kategorii</li>
//                     )}
//                   </ul>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="col-span-2 text-center py-12">
//               <p className="text-gray-500 text-xl">Brak dostępnych kategorii atrakcji</p>
//             </div>
//           )}
//         </div>

//         {attractionsData.details.otherPlaces && attractionsData.details.otherPlaces.length > 0 && (
//           <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
//             <h2 className="text-2xl font-bold text-gray-800 mb-6">Inne wyjątkowe miejsca w okolicy</h2>
//             <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
//               {attractionsData.details.otherPlaces.map((item, index) => (
//                 <div key={index} className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200">
//                   <span className="text-yellow-500 mr-3 text-lg">•</span>
//                   <span className="text-gray-700">{item}</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         <div className="bg-blue-50 rounded-xl p-6 mb-8 border border-blue-200">
//           <h3 className="text-xl font-semibold text-blue-800 mb-3">Planujesz pobyt?</h3>
//           <p className="text-blue-700">
//             Wszystkie wymienione atrakcje znajdują się w odległości do 30 km od Jastrzębiej Góry. 
//             Idealne na jednodniowe wycieczki podczas Twojego pobytu w naszych domkach.
//           </p>
//         </div>

//         <div className="mt-12 text-center">
//           <Link 
//             to="/" 
//             className="inline-block bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-full transition-colors duration-300 transform hover:scale-105"
//           >
//             Powrót do strony głównej
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AttractionsDetails;

// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';

// const AttractionsDetails = () => {
//   const API_BASE = process.env.NODE_ENV === 'production' 
//     ? '/api'  // Zmienione na /api zamiast /kolorowedomki/api
//     : 'http://localhost/api';
  
//   const [attractionsData, setAttractionsData] = useState({
//     details: {
//       title: "Atrakcje Jastrzębiej Góry i okolic",
//       description: "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy",
//       categories: [],
//       otherPlaces: []
//     }
//   });
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [imageErrors, setImageErrors] = useState({});

//   // Placeholder images jako fallback
//   const placeholderImages = {
//     nature: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='200' viewBox='0 0 400 200'%3E%3Crect width='400' height='200' fill='%234f46e5'/%3E%3Cpath d='M0,150 Q100,100 200,150 T400,150 L400,200 L0,200 Z' fill='%2310b981'/%3E%3Ccircle cx='100' cy='50' r='30' fill='%23fbbf24'/%3E%3Ctext x='200' y='110' text-anchor='middle' fill='white' font-family='Arial' font-size='16'%3EAtrakcje Przyrodnicze%3C/text%3E%3C/svg%3E",
//     history: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='200' viewBox='0 0 400 200'%3E%3Crect width='400' height='200' fill='%23dc2626'/%3E%3Crect x='150' y='80' width='100' height='70' fill='%23f59e0b'/%3E%3Crect x='160' y='90' width='20' height='40' fill='%237f1d1d'/%3E%3Crect x='220' y='90' width='20' height='30' fill='%237f1d1d'/%3E%3Ctext x='200' y='180' text-anchor='middle' fill='white' font-family='Arial' font-size='16'%3EAtrakcje Historyczne%3C/text%3E%3C/svg%3E",
//     activity: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='200' viewBox='0 0 400 200'%3E%3Crect width='400' height='200' fill='%230ea5e9'/%3E%3Ccircle cx='120' cy='100' r='25' fill='white'/%3E%3Ccircle cx='280' cy='100' r='25' fill='white'/%3E%3Crect x='95' y='80' width='50' height='40' fill='%23ef4444'/%3E%3Ctext x='200' y='180' text-anchor='middle' fill='white' font-family='Arial' font-size='16'%3EAktywny Wypoczynek%3C/text%3E%3C/svg%3E",
//     family: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='200' viewBox='0 0 400 200'%3E%3Crect width='400' height='200' fill='%238b5cf6'/%3E%3Ccircle cx='150' cy='80' r='20' fill='%23fbbf24'/%3E%3Ccircle cx='250' cy='80' r='20' fill='%23fbbf24'/%3E%3Cpath d='M130,100 Q150,150 170,100 M230,100 Q250,150 270,100' stroke='%23fbbf24' stroke-width='8' fill='none'/%3E%3Ctext x='200' y='180' text-anchor='middle' fill='white' font-family='Arial' font-size='16'%3EDla Rodzin z Dziećmi%3C/text%3E%3C/svg%3E"
//   };

//   const getPlaceholderByTitle = (title) => {
//     if (title?.includes('Przyrodnicze')) return placeholderImages.nature;
//     if (title?.includes('Historyczne')) return placeholderImages.history;
//     if (title?.includes('Aktywny')) return placeholderImages.activity;
//     if (title?.includes('Rodzin')) return placeholderImages.family;
//     return placeholderImages.nature;
//   };

//   const handleImageError = (categoryIndex) => {
//     setImageErrors(prev => ({ ...prev, [categoryIndex]: true }));
//   };

//   const getImageSrc = (category, index) => {
//     if (!category || !category.image || imageErrors[index]) {
//       return getPlaceholderByTitle(category?.title);
//     }
//     return category.image;
//   };

//   useEffect(() => {
//     window.scrollTo(0, 0);
    
//     const fetchAttractionsData = async () => {
//       try {
//         setLoading(true);
//         setError(null);
        
//         console.log('Pobieranie danych z:', `${API_BASE}/attractions.php`);
        
//         const response = await fetch(`${API_BASE}/attractions.php`, {
//           method: 'GET',
//           headers: {
//             'Accept': 'application/json',
//             'Content-Type': 'application/json',
//           },
//         });
        
//         console.log('Status odpowiedzi:', response.status);
//         console.log('URL:', response.url);
        
//         if (!response.ok) {
//           // Sprawdź czy to problem z CORS czy z serwerem
//           const errorText = await response.text();
//           console.log('Treść błędu:', errorText);
//           throw new Error(`Błąd HTTP: ${response.status} - ${response.statusText}`);
//         }
        
//         const responseText = await response.text();
//         console.log('Otrzymane dane (pierwsze 500 znaków):', responseText.substring(0, 500));
        
//         if (!responseText.trim()) {
//           throw new Error('Pusta odpowiedź z serwera');
//         }
        
//         const data = JSON.parse(responseText);
//         console.log('Sparsowane dane:', data);
//         setAttractionsData(data);
        
//       } catch (error) {
//         console.error('Błąd ładowania danych atrakcji:', error);
        
//         if (error instanceof SyntaxError) {
//           setError('Serwer zwrócił nieprawidłowy format JSON. Sprawdź czy API działa poprawnie.');
//         } else if (error.message.includes('CORS') || error.message.includes('NetworkError')) {
//           setError('Problem z połączeniem z serwerem. Sprawdź konfigurację CORS.');
//         } else {
//           setError(`Nie udało się załadować danych: ${error.message}`);
//         }
        
//         // Tymczasowe dane tylko do testów UI
//         setAttractionsData({
//           details: {
//             title: "Atrakcje Jastrzębiej Góry i okolic",
//             description: "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy",
//             categories: [
//               {
//                 title: "Atrakcje Przyrodnicze",
//                 image: "/images/krajobraz.jpg",
//                 items: ["Ładowanie..."]
//               },
//               {
//                 title: "Atrakcje Historyczne", 
//                 image: "/images/zabytki.jpg",
//                 items: ["Ładowanie..."]
//               }
//             ],
//             otherPlaces: ["Ładowanie..."]
//           }
//         });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAttractionsData();
//   }, [API_BASE]);

//   if (loading) {
//     return (
//       <div className="bg-[#edece8] min-h-screen py-12 flex items-center justify-center">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
//         <p className="ml-4 text-gray-600">Ładowanie atrakcji z serwera...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-[#edece8] min-h-screen py-12">
//       <div className="max-w-6xl mx-auto px-4">
//         {/* Komunikat o błędzie */}
//         {error && (
//           <div className="mb-6 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
//             <strong>Uwaga:</strong> {error}
//             <div className="mt-2 text-sm">
//               Sprawdź czy plik <code>attractions.php</code> istnieje i zwraca poprawny JSON.
//             </div>
//           </div>
//         )}

//         <div className="text-center mb-12">
//           <h1 className="text-4xl font-bold text-gray-800 mb-4">
//             {attractionsData.details?.title || "Atrakcje Jastrzębiej Góry i okolic"}
//           </h1>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//             {attractionsData.details?.description || "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy"}
//           </p>
//         </div>

//         <div className="grid md:grid-cols-2 gap-8 mb-12">
//           {attractionsData.details.categories && attractionsData.details.categories.length > 0 ? (
//             attractionsData.details.categories.map((category, index) => (
//               <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
//                 <div className="h-48 overflow-hidden bg-gray-200">
//                   <img 
//                     src={getImageSrc(category, index)}
//                     alt={category.title || "Kategoria"}
//                     className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
//                     onError={() => handleImageError(index)}
//                   />
//                 </div>
//                 <div className="p-6">
//                   <h2 className="text-2xl font-bold text-yellow-600 mb-4">
//                     {category.title || "Kategoria atrakcji"}
//                   </h2>
//                   <ul className="space-y-2">
//                     {category.items && category.items.length > 0 ? (
//                       category.items.map((item, i) => (
//                         <li key={i} className="flex items-start text-gray-700 hover:text-gray-900 transition-colors duration-200">
//                           <span className="text-yellow-500 mr-2 mt-1">•</span>
//                           <span>{item}</span>
//                         </li>
//                       ))
//                     ) : (
//                       <li className="text-gray-500">Brak atrakcji w tej kategorii</li>
//                     )}
//                   </ul>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="col-span-2 text-center py-12">
//               <p className="text-gray-500 text-xl">Brak dostępnych kategorii atrakcji w API</p>
//             </div>
//           )}
//         </div>

//         {attractionsData.details.otherPlaces && attractionsData.details.otherPlaces.length > 0 && (
//           <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
//             <h2 className="text-2xl font-bold text-gray-800 mb-6">Inne wyjątkowe miejsca w okolicy</h2>
//             <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
//               {attractionsData.details.otherPlaces.map((item, index) => (
//                 <div key={index} className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200">
//                   <span className="text-yellow-500 mr-3 text-lg">•</span>
//                   <span className="text-gray-700">{item}</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         <div className="mt-12 text-center">
//           <Link 
//             to="/" 
//             className="inline-block bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-full transition-colors duration-300 transform hover:scale-105"
//           >
//             Powrót do strony głównej
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AttractionsDetails;

// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';

// const AttractionsDetails = () => {
//   const API_BASE = process.env.NODE_ENV === 'production' 
//     ? '/api'
//     : 'http://localhost/api';
  
//   const [attractionsData, setAttractionsData] = useState({
//     details: {
//       title: "Atrakcje Jastrzębiej Góry i okolic",
//       description: "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy",
//       categories: [],
//       otherPlaces: []
//     }
//   });
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [imageErrors, setImageErrors] = useState({});

//   // Funkcja do dekodowania base64
// const decodeBase64 = (str) => {
//   try {
//     // Sprawdź czy to base64 (opcjonalne)
//     if (!str || str.trim() === '') return str;
    
//     // Metoda 1: decodeURIComponent z escape
//     try {
//       const binaryString = atob(str);
//       const utf8String = decodeURIComponent(escape(binaryString));
//       return utf8String;
//     } catch (e) {
//       // Metoda 2: TextDecoder
//       const binaryString = atob(str);
//       const bytes = new Uint8Array(binaryString.length);
//       for (let i = 0; i < binaryString.length; i++) {
//         bytes[i] = binaryString.charCodeAt(i);
//       }
//       return new TextDecoder('utf-8').decode(bytes);
//     }
//   } catch {
//     // Jeśli wszystko zawiedzie, zwróć oryginalny string
//     return str;
//   }
// };

//   // Funkcja do przetwarzania danych z API
//   const processApiData = (data) => {
//     if (data.details?.encoded) {
//       // Dekoduj zakodowane dane
//       return {
//         details: {
//           title: decodeBase64(data.details.title),
//           description: decodeBase64(data.details.description),
//           categories: data.details.categories.map(category => ({
//             title: decodeBase64(category.title),
//             image: category.image,
//             items: category.items.map(item => decodeBase64(item))
//           })),
//           otherPlaces: data.details.otherPlaces.map(place => decodeBase64(place))
//         }
//       };
//     }
//     return data;
//   };

//   // Placeholder images jako fallback
//   const placeholderImages = {
//     nature: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='200' viewBox='0 0 400 200'%3E%3Crect width='400' height='200' fill='%234f46e5'/%3E%3Cpath d='M0,150 Q100,100 200,150 T400,150 L400,200 L0,200 Z' fill='%2310b981'/%3E%3Ccircle cx='100' cy='50' r='30' fill='%23fbbf24'/%3E%3Ctext x='200' y='110' text-anchor='middle' fill='white' font-family='Arial' font-size='16'%3EAtrakcje Przyrodnicze%3C/text%3E%3C/svg%3E",
//     history: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='200' viewBox='0 0 400 200'%3E%3Crect width='400' height='200' fill='%23dc2626'/%3E%3Crect x='150' y='80' width='100' height='70' fill='%23f59e0b'/%3E%3Crect x='160' y='90' width='20' height='40' fill='%237f1d1d'/%3E%3Crect x='220' y='90' width='20' height='30' fill='%237f1d1d'/%3E%3Ctext x='200' y='180' text-anchor='middle' fill='white' font-family='Arial' font-size='16'%3EAtrakcje Historyczne%3C/text%3E%3C/svg%3E",
//     activity: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='200' viewBox='0 0 400 200'%3E%3Crect width='400' height='200' fill='%230ea5e9'/%3E%3Ccircle cx='120' cy='100' r='25' fill='white'/%3E%3Ccircle cx='280' cy='100' r='25' fill='white'/%3E%3Crect x='95' y='80' width='50' height='40' fill='%23ef4444'/%3E%3Ctext x='200' y='180' text-anchor='middle' fill='white' font-family='Arial' font-size='16'%3EAktywny Wypoczynek%3C/text%3E%3C/svg%3E",
//     family: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='200' viewBox='0 0 400 200'%3E%3Crect width='400' height='200' fill='%238b5cf6'/%3E%3Ccircle cx='150' cy='80' r='20' fill='%23fbbf24'/%3E%3Ccircle cx='250' cy='80' r='20' fill='%23fbbf24'/%3E%3Cpath d='M130,100 Q150,150 170,100 M230,100 Q250,150 270,100' stroke='%23fbbf24' stroke-width='8' fill='none'/%3E%3Ctext x='200' y='180' text-anchor='middle' fill='white' font-family='Arial' font-size='16'%3EDla Rodzin z Dziećmi%3C/text%3E%3C/svg%3E"
//   };

//   const getPlaceholderByTitle = (title) => {
//     if (title?.includes('Przyrodnicze')) return placeholderImages.nature;
//     if (title?.includes('Historyczne')) return placeholderImages.history;
//     if (title?.includes('Aktywny')) return placeholderImages.activity;
//     if (title?.includes('Rodzin')) return placeholderImages.family;
//     return placeholderImages.nature;
//   };

//   const handleImageError = (categoryIndex) => {
//     setImageErrors(prev => ({ ...prev, [categoryIndex]: true }));
//   };

//   const getImageSrc = (category, index) => {
//     if (!category || !category.image || imageErrors[index]) {
//       return getPlaceholderByTitle(category?.title);
//     }
//     return category.image;
//   };

//   useEffect(() => {
//     window.scrollTo(0, 0);
    
//     const fetchAttractionsData = async () => {
//       try {
//         setLoading(true);
//         setError(null);
        
//         console.log('Pobieranie danych z:', `${API_BASE}/attractions.php`);
        
//         const response = await fetch(`${API_BASE}/attractions.php`, {
//           method: 'GET',
//           headers: {
//             'Accept': 'application/json',
//             'Content-Type': 'application/json',
//           },
//         });
        
//         console.log('Status odpowiedzi:', response.status);
//         console.log('URL:', response.url);
        
//         if (!response.ok) {
//           const errorText = await response.text();
//           console.log('Treść błędu:', errorText);
//           throw new Error(`Błąd HTTP: ${response.status} - ${response.statusText}`);
//         }
        
//         const responseText = await response.text();
//         console.log('Otrzymane dane (pierwsze 500 znaków):', responseText.substring(0, 500));
        
//         if (!responseText.trim()) {
//           throw new Error('Pusta odpowiedź z serwera');
//         }
        
//         const data = JSON.parse(responseText);
//         console.log('Sparsowane dane przed przetworzeniem:', data);
        
//         // PRZETWÓRZ DANE - dekoduj base64 jeśli potrzeba
//         const processedData = processApiData(data);
//         console.log('Dane po przetworzeniu:', processedData);
        
//         setAttractionsData(processedData);
        
//       } catch (error) {
//         console.error('Błąd ładowania danych atrakcji:', error);
        
//         if (error instanceof SyntaxError) {
//           setError('Serwer zwrócił nieprawidłowy format JSON. Sprawdź czy API działa poprawnie.');
//         } else if (error.message.includes('CORS') || error.message.includes('NetworkError')) {
//           setError('Problem z połączeniem z serwerem. Sprawdź konfigurację CORS.');
//         } else {
//           setError(`Nie udało się załadować danych: ${error.message}`);
//         }
        
//         // Tymczasowe dane tylko do testów UI
//         setAttractionsData({
//           details: {
//             title: "Atrakcje Jastrzębiej Góry i okolic",
//             description: "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy",
//             categories: [
//               {
//                 title: "Atrakcje Przyrodnicze",
//                 image: "/images/krajobraz.jpg",
//                 items: ["Ładowanie..."]
//               },
//               {
//                 title: "Atrakcje Historyczne", 
//                 image: "/images/zabytki.jpg",
//                 items: ["Ładowanie..."]
//               }
//             ],
//             otherPlaces: ["Ładowanie..."]
//           }
//         });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAttractionsData();
//   }, [API_BASE]);

//   if (loading) {
//     return (
//       <div className="bg-[#edece8] min-h-screen py-12 flex items-center justify-center">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
//         <p className="ml-4 text-gray-600">Ładowanie atrakcji z serwera...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-[#edece8] min-h-screen py-12">
//       <div className="max-w-6xl mx-auto px-4">
//         {/* Komunikat o błędzie */}
//         {error && (
//           <div className="mb-6 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
//             <strong>Uwaga:</strong> {error}
//             <div className="mt-2 text-sm">
//               Sprawdź czy plik <code>attractions.php</code> istnieje i zwraca poprawny JSON.
//             </div>
//           </div>
//         )}

//         <div className="text-center mb-12">
//           <h1 className="text-4xl font-bold text-gray-800 mb-4">
//             {attractionsData.details?.title || "Atrakcje Jastrzębiej Góry i okolic"}
//           </h1>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//             {attractionsData.details?.description || "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy"}
//           </p>
//         </div>

//         <div className="grid md:grid-cols-2 gap-8 mb-12">
//           {attractionsData.details.categories && attractionsData.details.categories.length > 0 ? (
//             attractionsData.details.categories.map((category, index) => (
//               <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
//                 <div className="h-48 overflow-hidden bg-gray-200">
//                   <img 
//                     src={getImageSrc(category, index)}
//                     alt={category.title || "Kategoria"}
//                     className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
//                     onError={() => handleImageError(index)}
//                   />
//                 </div>
//                 <div className="p-6">
//                   <h2 className="text-2xl font-bold text-yellow-600 mb-4">
//                     {category.title || "Kategoria atrakcji"}
//                   </h2>
//                   <ul className="space-y-2">
//                     {category.items && category.items.length > 0 ? (
//                       category.items.map((item, i) => (
//                         <li key={i} className="flex items-start text-gray-700 hover:text-gray-900 transition-colors duration-200">
//                           <span className="text-yellow-500 mr-2 mt-1">•</span>
//                           <span>{item}</span>
//                         </li>
//                       ))
//                     ) : (
//                       <li className="text-gray-500">Brak atrakcji w tej kategorii</li>
//                     )}
//                   </ul>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="col-span-2 text-center py-12">
//               <p className="text-gray-500 text-xl">Brak dostępnych kategorii atrakcji w API</p>
//             </div>
//           )}
//         </div>

//         {attractionsData.details.otherPlaces && attractionsData.details.otherPlaces.length > 0 && (
//           <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
//             <h2 className="text-2xl font-bold text-gray-800 mb-6">Inne wyjątkowe miejsca w okolicy</h2>
//             <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
//               {attractionsData.details.otherPlaces.map((item, index) => (
//                 <div key={index} className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200">
//                   <span className="text-yellow-500 mr-3 text-lg">•</span>
//                   <span className="text-gray-700">{item}</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         <div className="mt-12 text-center">
//           <Link 
//             to="/" 
//             className="inline-block bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-full transition-colors duration-300 transform hover:scale-105"
//           >
//             Powrót do strony głównej
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AttractionsDetails;

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const AttractionsDetails = () => {
  const [attractionsData, setAttractionsData] = useState({
    details: {
      title: "Atrakcje Jastrzębiej Góry i okolic",
      description: "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy",
      categories: [],
      otherPlaces: []
    }
  });
  const [loading, setLoading] = useState(true);
  const [imageErrors, setImageErrors] = useState({});

  // DANE LOKALNE - na stałe w komponencie
  const localAttractionsData = {
    details: {
      title: "Atrakcje Jastrzębiej Góry i okolic",
      description: "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy",
      categories: [
        {
          title: "Atrakcje Przyrodnicze",
          image: "/images/krajobraz.jpg",
          items: [
            "Klif w Jastrzębiej Górze",
            "Rezerwat Przylądek Rozewie", 
            "Latarnia morska w Rozewiu",
            "Plaża w Jastrzębiej Górze",
            "Lisi Jar - malowniczy wąwóz",
            "Rezerwat Bielawa - torfowiska"
          ]
        },
        {
          title: "Atrakcje Historyczne",
          image: "/images/zabytki.jpg", 
          items: [
            "Muzeum Latarnictwa w Rozewiu",
            "Dworek Drzewiarza w Jastrzębiej Górze",
            "Stara Chata Rybacka",
            "Kościół św. Ignacego",
            "Fortyfikacje z II Wojny Światowej"
          ]
        },
        {
          title: "Aktywny Wypoczynek",
          image: "/images/aktywnywypoczynek.jpg",
          items: [
            "Szlaki rowerowe Północnych Kaszub",
            "Spływy kajakowe Redą",
            "Surfowanie na plaży w Jastrzębiej Górze",
            "Trasy nordic walking",
            "Rejsy kutrem rybackim"
          ]
        },
        {
          title: "Dla Rodzin z Dziećmi",
          image: "/images/atrakcjedlarodzin.jpg",
          items: [
            "Ocean Park we Władysławowie",
            "Lunapark Sowiński",
            "Park Rozrywki w Redłowie",
            "Fokarium na Helu",
            "Park Miniatur w Dobrzycy"
          ]
        }
      ],
      otherPlaces: [
        "Władysławowo - słynny port rybacki",
        "Chłapowo - malownicza wioska rybacka", 
        "Rozewie - najstarsza latarnia morska",
        "Gdynia - nowoczesne miasto portowe",
        "Gdańsk - historyczne stare miasto",
        "Hel - półwysep i fokarium",
        "Puck - miasto z historią hanzeatycką",
        "Żarnowiec - jezioro i elektrownia"
      ]
    }
  };

  // Placeholder images jako fallback
  const placeholderImages = {
    nature: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='200' viewBox='0 0 400 200'%3E%3Crect width='400' height='200' fill='%234f46e5'/%3E%3Cpath d='M0,150 Q100,100 200,150 T400,150 L400,200 L0,200 Z' fill='%2310b981'/%3E%3Ccircle cx='100' cy='50' r='30' fill='%23fbbf24'/%3E%3Ctext x='200' y='110' text-anchor='middle' fill='white' font-family='Arial' font-size='16'%3EAtrakcje Przyrodnicze%3C/text%3E%3C/svg%3E",
    history: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='200' viewBox='0 0 400 200'%3E%3Crect width='400' height='200' fill='%23dc2626'/%3E%3Crect x='150' y='80' width='100' height='70' fill='%23f59e0b'/%3E%3Crect x='160' y='90' width='20' height='40' fill='%237f1d1d'/%3E%3Crect x='220' y='90' width='20' height='30' fill='%237f1d1d'/%3E%3Ctext x='200' y='180' text-anchor='middle' fill='white' font-family='Arial' font-size='16'%3EAtrakcje Historyczne%3C/text%3E%3C/svg%3E",
    activity: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='200' viewBox='0 0 400 200'%3E%3Crect width='400' height='200' fill='%230ea5e9'/%3E%3Ccircle cx='120' cy='100' r='25' fill='white'/%3E%3Ccircle cx='280' cy='100' r='25' fill='white'/%3E%3Crect x='95' y='80' width='50' height='40' fill='%23ef4444'/%3E%3Ctext x='200' y='180' text-anchor='middle' fill='white' font-family='Arial' font-size='16'%3EAktywny Wypoczynek%3C/text%3E%3C/svg%3E",
    family: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='200' viewBox='0 0 400 200'%3E%3Crect width='400' height='200' fill='%238b5cf6'/%3E%3Ccircle cx='150' cy='80' r='20' fill='%23fbbf24'/%3E%3Ccircle cx='250' cy='80' r='20' fill='%23fbbf24'/%3E%3Cpath d='M130,100 Q150,150 170,100 M230,100 Q250,150 270,100' stroke='%23fbbf24' stroke-width='8' fill='none'/%3E%3Ctext x='200' y='180' text-anchor='middle' fill='white' font-family='Arial' font-size='16'%3EDla Rodzin z Dziećmi%3C/text%3E%3C/svg%3E"
  };

  const getPlaceholderByTitle = (title) => {
    if (title?.includes('Przyrodnicze')) return placeholderImages.nature;
    if (title?.includes('Historyczne')) return placeholderImages.history;
    if (title?.includes('Aktywny')) return placeholderImages.activity;
    if (title?.includes('Rodzin')) return placeholderImages.family;
    return placeholderImages.nature;
  };

  const handleImageError = (categoryIndex) => {
    setImageErrors(prev => ({ ...prev, [categoryIndex]: true }));
  };

  const getImageSrc = (category, index) => {
    if (!category || !category.image || imageErrors[index]) {
      return getPlaceholderByTitle(category?.title);
    }
    return category.image;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // UŻYWAMY DANYCH LOKALNYCH - BEZ API
    const timer = setTimeout(() => {
      setAttractionsData(localAttractionsData);
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="bg-[#edece8] min-h-screen py-12 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
        <p className="ml-4 text-gray-600">Ładowanie atrakcji...</p>
      </div>
    );
  }

  return (
    <div className="bg-[#edece8] min-h-screen py-12">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            {attractionsData.details.title}
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {attractionsData.details.description}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {attractionsData.details.categories.map((category, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="h-48 overflow-hidden bg-gray-200">
                <img 
                  src={getImageSrc(category, index)}
                  alt={category.title}
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                  onError={() => handleImageError(index)}
                />
              </div>
              <div className="p-6">
                <h2 className="text-2xl font-bold text-yellow-600 mb-4">
                  {category.title}
                </h2>
                <ul className="space-y-2">
                  {category.items.map((item, i) => (
                    <li key={i} className="flex items-start text-gray-700 hover:text-gray-900 transition-colors duration-200">
                      <span className="text-yellow-500 mr-2 mt-1">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Inne wyjątkowe miejsca w okolicy</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {attractionsData.details.otherPlaces.map((item, index) => (
              <div key={index} className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200">
                <span className="text-yellow-500 mr-3 text-lg">•</span>
                <span className="text-gray-700">{item}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-blue-50 rounded-xl p-6 mb-8 border border-blue-200">
          <h3 className="text-xl font-semibold text-blue-800 mb-3">Planujesz pobyt?</h3>
          <p className="text-blue-700">
            Wszystkie wymienione atrakcje znajdują się w odległości do 30 km od Jastrzębiej Góry. 
            Idealne na jednodniowe wycieczki podczas Twojego pobytu w naszych domkach.
          </p>
        </div>

        <div className="mt-12 text-center">
          <Link 
            to="/" 
            className="inline-block bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-full transition-colors duration-300 transform hover:scale-105"
          >
            Powrót do strony głównej
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AttractionsDetails;